import type { User } from 'features/auth';
import { isOrganizationAdminProfile, isOrganizationsAdmin, isSuperAdmin } from '../utils';

export const canViewAdminDashboardOrganizations = ({ viewer }: { viewer: User }) =>
  isSuperAdmin({ viewer: viewer.railsUserData }) || isOrganizationsAdmin({ viewer: viewer.railsUserData });

const canCreateTags = ({ organizationId, viewer }: { organizationId?: string; viewer: User }) =>
  isSuperAdmin({ viewer: viewer.railsUserData }) ||
  Boolean(organizationId && isOrganizationAdminProfile({ organizationId, viewer: viewer.railsUserData }));

export const canSeeTags = ({ organizationId, viewer }: { organizationId: string; viewer: User }) =>
  canCreateTags({ organizationId, viewer });
